<template>
	<div class="page" :style="{ height: fixedHeight + 'px' }">
		<div class="searchbox">
			<div style="margin-left: 10px;">
				<el-input style="width:160px;margin-right: 10px;" placeholder="请输入名称" v-model="params.keyword"
					@keyup.enter.native="clickSearch" clearable size="small"></el-input>
				<el-button @click="clickSearch" icon="el-icon-search" type="warning" size="small">搜索</el-button>
			</div>
			<div style="margin-left: 10px;">
				<el-select v-model="params.shopId" placeholder="请选择" clearable @change="clickSearch" size="small"
					style="width: 120px;">
					<el-option v-for="item in this.$store.state.userInfo.shops" :key="item.shop_id" :label="item.shop_name"
						:value="item.shop_id">
					</el-option>
				</el-select>
			</div>
			<div style="margin-left: 10px;">
				<el-select v-model="params.applytype" placeholder="请选择种类" clearable @change="clickSearch" size="small"
					style="width: 120px;">
					<el-option label="通用" value="0"></el-option>
					<el-option label="犬用" value="2"></el-option>
					<el-option label="猫用" value="1"></el-option>
				</el-select>
			</div>
			<div style="margin-left: 10px;text-align: right;margin-right: 10px;flex: 1;">
				<!-- <el-button icon="el-icon-plus" type="primary" @click="addProductType('')">新建类型</el-button> -->
				<el-button v-if="$buttonAuthority('chanpin-medicalservice-add')" icon="el-icon-plus" type="warning" @click='addService()' size="small">新建服务</el-button>
			</div>
		</div>
		<div class="con" :style="{ height: fixedHeight - 82 + 'px' }">
			<div class="left">
				<el-button style="margin-left: 20px;" size="mini" @click="addProductType('')">添加</el-button>
				<el-button size="mini" type="warning" @click="resetProductType">重置</el-button>
				<el-tree class="elTree" style="margin-top: 10px;" v-if="categoryData[0]" :data="categoryData[0].children"
					:highlight-current='isHighlight' node-key="id" default-expand-all :expand-on-click-node="false"
					:render-content="renderContent" @node-click='handleNodeClick'>
				</el-tree>
			</div>
			<div class="table">
				<el-table :data="washData" style="width: 100%">
					<el-table-column prop="title" label="项目名称">
					</el-table-column>
					<el-table-column prop="name" label="适用宠物">
						<template slot-scope="scope">
							<span>{{ scope.row.apply_type.title }}</span>
						</template>
					</el-table-column>
					<el-table-column label="分类">
						<template slot-scope="scope">
							<span>{{ scope.row.category_info.name }}</span>
						</template>
					</el-table-column>
					<el-table-column label="参与提成">
						<template slot-scope="scope">
							<span>{{ scope.row.join_commission == 0 ? '否' : '是' }}</span>
						</template>
					</el-table-column>

					<!-- <el-table-column  label="适用门店">
						<template slot-scope="scope">
							<div v-for="item in scope.row.shop_info" :key='item.shop_id'>{{item.shop_name}}</div>
						</template>
					</el-table-column> -->
					<!-- <el-table-column prop="remark" label="备注">
					</el-table-column> -->
					<el-table-column label="操作" width="180px">
						<template slot-scope="scope">
							<el-button v-if="$buttonAuthority('chanpin-medicalservice-edit')" type="text" icon='el-icon-edit' size="small" @click='edit(scope.row.serviceId)'>
								编辑</el-button>
							<el-button type="text" size="small" @click='relationconsum(scope.row)'>关联耗材</el-button>
							<!-- <el-button type="text" icon='el-icon-view' size="small" @click='lookdetail(scope.row._id)'>查看</el-button> -->
							<el-button v-if="$buttonAuthority('chanpin-medicalservice-del')" type="text" icon='el-icon-delete' size="small"
								@click='deleted(scope.row.serviceId)'>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<page :total="total" :page="params.pageIndex" @change="changePage" style="padding: 10px 0;"></page>
			</div>
		</div>

		<el-dialog title="医疗服务类型设置" :visible.sync="dialogProductType" width="30%" :close-on-click-modal='false'>
			<el-form ref="editProductParams" label-width="80px">
				<el-form-item label="类型名称">
					<el-input v-model="editProductParams.typeName" size='mini' style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="warning" @click="onSubmitProductType">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>


	</div>
</template>

<script>
import page from "../../../components/page.vue"
import {
	getMedicalServiceList,
	deleteMedicalService,
	getProductTypeList,
	setProductType,
	deleteProductType,
	getProductTypeDl
} from '../../../api/productApi.js'
export default {
	components: {
		page,
	},
	data() {
		return {
			fixedHeight: '',
			dialogWashService: false,
			washData: [],
			isHighlight: true,
			params: {
				keyword: '',
				applytype: '',
				categoryId: '',
				servicecategory: '',
				shopId: this.$store.getters.curShopInfo.shop_id,
				pageIndex: 1,
				pageSize: 10,
			},
			total: 0,
			productTypeIds: [],
			categoryData: [],
			dialogProductType: false,
			editProductParams: {
				status: 1,
				category: '医疗服务',
				typeName: '',
				parentId: '',
			},

			storeIds: [],
		}
	},

	methods: {
		getMedicalServiceList() {
			getMedicalServiceList(this.params).then(res => {
				if (res.code == 0) {
					console.log(res)
					this.washData = res.data.data;
					this.total = res.data.count;
				}
			})
		},
		clickSearch() {
			this.params.pageIndex = 1;
			this.getMedicalServiceList();
		},
		changePage(val) {
			this.params.pageIndex = val;
			this.getMedicalServiceList();
		},
		addService() {
			this.$router.push({
				path: '/medicalservice/addmedicalservice',
			})
		},
		getStoreInfo(shopinfo) {
			this.editParams.shop_info = shopinfo;
		},

		edit(id) {
			this.$router.push({
				path: '/medicalservice/addmedicalservice',
				query: {
					id,
				}
			})
		},
		deleted(id) {
			this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				deleteMedicalService({
					id
				}).then(res => {
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.getMedicalServiceList();
					}
				})

			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		lookdetail(id) {
			console.log(id);
		},
		renderContent(h, {
			node,
			data
		}) {
			return (<span class="custom-tree-node"  v-if="$buttonAuthority('chanpin-goods-sort')">
				<span > {
						node.label
					} </span> <span class='custom-tree-btn' >
						<el-button size="mini" type="text" icon='el-icon-plus'
							on-click={
								() => this.addProductType(data)
							} > </el-button> <el-button size="mini" type="text" icon='el-icon-edit'
								on-click={
									() => this.editProductType(data)
								} > </el-button> <el-button size="mini"
									type="text"
									icon='el-icon-delete'
									on-click={
										() => this.remove(node, data)
									} > </el-button> </span> </span>
							)
			},
							addProductType(data) {
				if (data) {
								this.editProductParams.parentId = data.id;
							this.editProductParams.typeName = '';
							this.editProductParams.typeId = '';
				} else {
								this.editProductParams.parentId = this.categoryData[0].id;
							this.editProductParams.typeName = '';
				}

							this.dialogProductType = true;

			},

							onSubmitProductType() {
				if (!this.editProductParams.typeName) {
								this.$message({
									type: 'warning',
									message: '类型名称不能为空'
								});
				} else {
								setProductType(this.editProductParams).then(res => {
									if (res.code == 0) {
										this.$message({
											type: 'success',
											message: '设置成功'
										});
										this.dialogProductType = false;
										this.getProductTypeList();
									}
								})
							}

			},
							remove(node, data) {
								this.$confirm('请谨慎操作！此操作将永久删除此类型，那么关联此类型的服务将被波及?', '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {
									deleteProductType({
										id: data.id
									}).then(res => {
										if (res.code == 0) {
											this.$message({
												type: 'success',
												message: '删除成功!'
											});
											this.getProductTypeList();
										}
									})

								}).catch(() => {
									this.$message({
										type: 'info',
										message: '已取消删除'
									});
								});

			},
							getProductTypeList() {
								getProductTypeList({
									category: '医疗服务'
								}).then(res => {
									if (res.code == 0) {
										this.categoryData = res.data;

									}
								})
							},
							editProductType(data) {
								this.dialogProductType = true;
							this.editProductParams.typeId = data.id;
							this.editProductParams.typeName = data.label;
							this.editProductParams.parentId = '';

			},
							handleNodeClick(data) {

								this.params.categoryId = data.id;
							this.getMedicalServiceList();
			},
							changeCategory(val) {
				if (val.length > 0) {
								getProductTypeDl({
									id: val[val.length - 1]
								}).then(res => {
									if (res.code == 0) {
										this.editParams.basic_info.category_info['name'] = res.data.name;
										this.editParams.basic_info.category_info['_id'] = res.data._id;
										this.editParams.basic_info.category_list = res.data.parent_all;
									}
								})
							}
			},
							resetProductType() {
								this.isHighlight = false;
							this.params.categoryId = '';
							this.getProductTypeList();
			},
							relationconsum(row) {
								this.$router.push({
									path: '/medicalservice/relationconsum',
									query: {
										product_name: row.title,
										product_id: row.serviceId,
										relation_type: 2,
									}
								})
							}
		},
							created() {
								this.fixedHeight = document.documentElement.clientHeight - 86;
							this.getMedicalServiceList();
							this.getProductTypeList()
		}
	}
</script>

<style lang="scss" scoped>
.page {
	.searchbox {
		background-color: #fff;
		height: 72px;
		display: flex;
		align-items: center;
	}

	.con {
		display: flex;
		margin-top: 20px;

		.left {
			width: 180px;
			background-color: #fff;
			margin-right: 20px;
			padding: 10px;
			overflow-y: scroll;

			&::-webkit-scrollbar {
				width: 4px;
				// height: 4px;
			}

			.elTree {
				font-size: 12px;

				::v-deep .custom-tree-node {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 12px;
					padding-right: 8px;
				}

				::v-deep .custom-tree-btn {
					display: none;
				}

				::v-deep .custom-tree-node:hover .custom-tree-btn {
					display: block;
				}
			}
		}

		.table {
			flex: 1;
			background-color: #fff;
			padding: 0 20px;
		}
	}
}

.custom-tree-node {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 12px;
	// padding-right: 8px;
}

.custom-tree-btn {
	display: none;
}

.custom-tree-node:hover .custom-tree-btn {
	display: block;
}</style>
